<template>
  <div
    v-focusable
    :class="_.stepper"
    @left="handleMinusClick"
    @right="handlePlusClick"
  >
    <tv-icon name="minus" :class="[_.action, minusDisabled && _.disabled]" />
    <div :class="_.value">{{ value }}</div>
    <tv-icon name="plus" :class="[_.action, plusDisabled && _.disabled]" />
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      value: {
        type: Number,
        required: true,
      },
      min: {
        type: Number,
        default: 1,
      },
      max: {
        type: Number,
        default: Infinity,
      },
    },

    computed: {
      minusDisabled() {
        return this.value <= this.min
      },
      plusDisabled() {
        return this.value >= this.max
      },
    },

    methods: {
      handleMinusClick() {
        if (!this.minusDisabled) {
          this.$emit('input', this.value - 1)
        }
        this.$tv.goTo(this.$el)
      },
      handlePlusClick() {
        if (!this.plusDisabled) {
          this.$emit('input', this.value + 1)
        }
        this.$tv.goTo(this.$el)
      },
    },
  })
</script>

<style lang="scss" module>
  .stepper {
    width: 360px;
    height: 80px;
    background: rgba(#333333, 0.05);
    border-radius: 16px;
    --border-radius: 16px;
    display: flex;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    color: #333333;

    .action {
      flex-shrink: 0;
      font-size: 40px;

      &.disabled {
        opacity: 0.6;
      }
    }

    .value {
      flex-grow: 1;
      text-align: center;
      font-size: 36px;
      font-weight: 500;
    }

    &[focused] {
      background: #e0251b;
      color: white;
    }
  }
</style>
